import { EMOJI_KEYWORDS } from "./emoji-keywords";

/**
 * Emoji search over the picker's own emoji: English and Arabic names and
 * tags (see emoji-keywords.ts). Every word typed must start one of an
 * emoji's words, so "hea" finds the hearts and "red hea" just ❤️.
 */

const AR_DIACRITICS = /[ؐ-ًؚ-ٰٟۖ-ۭـ]/g;

/** As the keywords were written: lower-case, Arabic letters unified. */
export const normalizeEmojiQuery = (q: string) =>
  q
    .toLowerCase()
    .replace(AR_DIACRITICS, "")
    .replace(/[أإآ]/g, "ا")
    .replace(/ى/g, "ي")
    .replace(/ة/g, "ه")
    .trim();

const wordsOf = new Map<string, string[]>();
const keywordWords = (emoji: string) => {
  let words = wordsOf.get(emoji);
  if (!words) {
    words = (EMOJI_KEYWORDS[emoji] ?? "").split(" ").filter(Boolean);
    wordsOf.set(emoji, words);
  }
  return words;
};

/**
 * The emoji of [pool] matching [query], in [pool]'s order but whole-word
 * matches first. Pasting an emoji finds itself.
 */
export const searchEmojis = (query: string, pool: readonly string[]): string[] => {
  const q = normalizeEmojiQuery(query);
  if (!q) return [];
  const tokens = q.split(/\s+/);
  const exact: string[] = [];
  const partial: string[] = [];
  for (const emoji of pool) {
    if (emoji === query.trim()) {
      exact.push(emoji);
      continue;
    }
    const words = keywordWords(emoji);
    if (!words.length) continue;
    if (!tokens.every((tok) => words.some((w) => w.startsWith(tok)))) continue;
    (tokens.every((tok) => words.includes(tok)) ? exact : partial).push(emoji);
  }
  return [...exact, ...partial];
};
